
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexnvlXDX1Iu2IZhNxdgAyO2qnucl3GsD_UjT0Kesua3HUMeta } from "/Users/rodrigolemos/meistrari/identity-provider/packages/auth-dashboard/pages/index.vue?macro=true";
import { default as loginajF03hPSjkq5Kzy9ZOou7IiWcMfJG8NdXprWrASa7GkMeta } from "/Users/rodrigolemos/meistrari/identity-provider/packages/auth-dashboard/pages/login.vue?macro=true";
import { default as loginwuFd99cgN7he5UH7H4TNezFeZQNLV4GHfoSnYkdGafwMeta } from "/Users/rodrigolemos/meistrari/identity-provider/packages/auth-dashboard/pages/applications/login.vue?macro=true";
import { default as pick_45org_CMmK3F5zgRj8h7uJqYyDo_459sCp4KQy_458FGFPYPVhmUMeta } from "/Users/rodrigolemos/meistrari/identity-provider/packages/auth-dashboard/pages/applications/pick-org.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexnvlXDX1Iu2IZhNxdgAyO2qnucl3GsD_UjT0Kesua3HUMeta || {},
    component: () => import("/Users/rodrigolemos/meistrari/identity-provider/packages/auth-dashboard/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginajF03hPSjkq5Kzy9ZOou7IiWcMfJG8NdXprWrASa7GkMeta || {},
    component: () => import("/Users/rodrigolemos/meistrari/identity-provider/packages/auth-dashboard/pages/login.vue")
  },
  {
    name: "applications-login",
    path: "/applications/login",
    meta: loginwuFd99cgN7he5UH7H4TNezFeZQNLV4GHfoSnYkdGafwMeta || {},
    component: () => import("/Users/rodrigolemos/meistrari/identity-provider/packages/auth-dashboard/pages/applications/login.vue")
  },
  {
    name: "applications-pick-org",
    path: "/applications/pick-org",
    meta: pick_45org_CMmK3F5zgRj8h7uJqYyDo_459sCp4KQy_458FGFPYPVhmUMeta || {},
    component: () => import("/Users/rodrigolemos/meistrari/identity-provider/packages/auth-dashboard/pages/applications/pick-org.vue")
  }
]